import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { SupplierRoutes } from "../../routes";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      margin: 12,
    },
  },
}));

let paramsData = {};

const AddEditRollDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [adminRoutes, setAdminRoutes] = useState([]);
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });

  const [inputError, setInputError] = useState({
    email: false,
    isValidEmail: false,
    password: false,
  });

  useEffect(() => {
    let tempArray = SupplierRoutes.map((val) => {
      return { ...val, selected: false };
    });
    setAdminRoutes(tempArray);
  }, []);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      setOpen(true);
      paramsData = params;
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValues({});
    setInputError({});
  };

  const handleChageInputs = (e) => {
    const { name, value } = e.target;

    setInputError((pre) => ({
      ...pre,
      [name]: false,
      isValidEmail: name === "email" ? false : inputError.isValidEmail,
    }));

    setInputValues((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleAssignedPages = (val, ind) => {
    let tempArray = [...adminRoutes];
    tempArray[ind].selected = !tempArray[ind].selected;
    console.log(tempArray, "sdasdsadsadsadasdsa");
    setAdminRoutes(tempArray);
  };

  const handleAddEditCategory = async () => {};

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      // scroll="body"
    >
      <IconButton
        onClick={handleClose}
        sx={{ position: "absolute", top: 5, right: 5 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle id="customized-dialog-title" sx={{ p: 2 }}>
        {paramsData.type === "add"
          ? t("newManagementRoles")
          : t("editManagementRoles")}
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} mt={1}>
          <Grid item xs={12}>
            <Label required labelText={t("email")} htmlFor={"email"} />
            <TextInput
              required
              inputError={inputError.email || inputError.isValidEmail}
              helperText={
                inputError.email
                  ? t("emailRequired")
                  : inputError.isValidEmail
                  ? t("invalidEmailFormat")
                  : null
              }
              id={"email"}
              placeholder={`${t("enter")} ${t("email")}`}
              name={"email"}
              value={inputValues.email}
              onChange={handleChageInputs}
            />
          </Grid>
          <Grid item xs={12}>
            <Label required labelText={t("password")} htmlFor={"password"} />
            <TextInput
              required
              inputError={inputError.password}
              helperText={inputError.password ? t("passwordRequired") : null}
              placeholder={`${t("enter")} ${t("password")}`}
              type={showPassword ? "text" : "password"}
              name={"password"}
              value={inputValues.password}
              onChange={handleChageInputs}
              InputEndIcon={
                showPassword ? (
                  <Typography
                    variant="body2"
                    color={appcolors.black}
                    onClick={() => setShowPassword(false)}
                  >
                    {t("hide")}
                  </Typography>
                ) : (
                  <Typography
                    variant="body2"
                    color={appcolors.black}
                    onClick={() => setShowPassword(true)}
                  >
                    {t("show")}
                  </Typography>
                )
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h1"
              fontWeight={600}
              fontSize={"1rem"}
              textTransform={"capitalize"}
            >
              {t("allModules")}
            </Typography>
            <List>
              {adminRoutes.map((valll, _ind) => {
                return (
                  <ListItem onClick={() => handleAssignedPages(valll, _ind)}>
                    <ListItemIcon sx={{ minWidth: 35 }}>
                      <img
                        src={
                          valll.selected
                            ? allIcons.checkSquareIcon
                            : allIcons.uncheckSquareIcon
                        }
                        alt="check-icon"
                        width={20}
                      />
                    </ListItemIcon>
                    <ListItemText secondary={valll.name} />
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={paramsData.type === "add" ? "addRoles" : "editRoles"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleAddEditCategory}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditRollDialog;
